
/* injects from baggage-loader */

'use strict';

import ProductVariantsComponent from './product.variants.component';

const ProductVariantsPageModule = angular.module('product-variants-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('product.variants', {
        data: {
          title: 'Variants'
        },
        url: '/variants?selected?page',
        component: 'productVariants',
        // Do not reload the page when updating query string
        reloadOnSearch: false,
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          config: function() {
            return {
              pagination: {
                currentPage: 1,
                pageSize: 1000,
                maxSize: 10
              }
            }
          },
          productsResponse: function(product, config, Parse, Product, $transition$) {
            // return Product.query(null, (query, getNewQuery, P) => {
            //   query.withCount(true);
            //   query.equalTo('parent', product);
            //   const currentPage = Number($transition$.params('to').page);
            //   if (currentPage) {
            //     config.pagination.currentPage = Number(currentPage);
            //     const skip = (currentPage * config.pagination.pageSize) - config.pagination.pageSize
            //     query.skip(skip);
            //   }
            //   return query;
            // });

            const query = new Parse.Query(Product);
            query.withCount(true);
            query.limit(1000);
            query.equalTo('parent', product);
            const currentPage = Number($transition$.params('to').page);
            if (currentPage) {
              config.pagination.currentPage = Number(currentPage);
              const skip = (currentPage * config.pagination.pageSize) - config.pagination.pageSize
              query.skip(skip);
            }

            return query.find();
          },
          products: function(productsResponse) {
            return productsResponse.results;
          },
          totalItemCount: function(productsResponse) {
            return productsResponse.count;
          },
          selectedProduct: function(products, Product, $transition$) {
            const selectedProductId = $transition$.params('to').selected;

            // Attempt to find the log in the current page results
            if (selectedProductId) {
              const cachedLog = products.find(p => p.id === selectedProductId);
              return cachedLog || Product.get(selectedProductId).catch(err => null);
            }

          }
        }
      });
  })
  .component('productVariants', new ProductVariantsComponent());

export default ProductVariantsPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/product/variants/product.variants.module.js